import { Moon, Sun } from "lucide-react";
import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../ui";
import { FC } from "react";
import { DarkModeProps } from "./type";
import { useDarkMode } from "../../hooks";

export const DarkMode: FC<DarkModeProps> = () => {
    const { setDarkMode } = useDarkMode();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon">
                    <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                    <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                    <span className="sr-only">Toggle theme</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => setDarkMode("light")}>
                    Light
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setDarkMode("dark")}>
                    Dark
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setDarkMode("system")}>
                    System
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
